import apiWrapper from '@/utils/apiHelpers/apiWrapper'
import qs from 'qs'

export const decodeVinSubaru = async ({ setBrand, vin, setVin, setLoadingVIN, setVINError, i18nL10n, t, router }) => {
  try {
    const { locale } = i18nL10n

    setVin(vin)
    setVINError(false)
    setLoadingVIN(true)

    const result = await apiWrapper.get(`publications/findCriteriaByVin/${vin}`)
    if (!result.success) setVINError(result.response.message)
    else {
      const { brand, model, modelType, year } = result.response
      const query = {
        brand,
        model,
        modelType,
        year,
        language: locale
      }

      setBrand(brand)
      router.push(`/publications?${qs.stringify(query)}`)
    }
  } catch (e) {
    if (e.response?.status === 400) {
      setVINError(t('vin_incorrect_format'))
    } else if (e.response?.status === 429) setVINError(t('rate_limit_exceeded'))
    else {
      console.error(e)
      setVINError(t('vin_decode_unavailable'))
    }
  } finally {
    setLoadingVIN(false)
  }
}
